import { Link } from 'react-router-dom'

import styled, { css } from 'styled-components'

export const OptionLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  text-decoration: none;
  width: 100%;
  color: black;
  white-space: nowrap;

  &:hover {
    cursor: pointer;
  }

  :visited {
    color: black;
  }

  :link {
    color: black;
  }
`

export const Option = styled.li`
  display: flex;
  height: ${props => props.theme.size.S};
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp12};
  flex-wrap: nowrap;
  overflow: hidden;
  border-radius: ${props => props.theme.primitives.radius.radius2};

  svg {
    min-width: ${props => props.theme.size.S};
  }

  ${props =>
    props.selected &&
    css`
      background-color: ${props.theme.colors.border.subtle};

      a {
        color: ${props.theme.colors.outline.default};
      }
    `}
`
